import * as PreworkReminderAction from './PreworkReminderAction';
import * as NpsReminderAction from './NpsRemindersAction';

export default {
  prework_reminder: PreworkReminderAction,
  nps_schedule: NpsReminderAction,
};
